<template>
  <div>
    <nav
      class="navbar navbar-expand-lg"
    >
      <a
        class="navbar-brand"
        href="https://casafile.ch"
        style="display: flex; align-items: center; padding-bottom: 8px"
      >
        <img
          alt="casafile Immobilien"
          id="logoImage"
          class="px-3"
          style="padding-bottom: 5px; height: 35px; width: auto"
          src="../../assets/logo.png"
        />
      </a>

      <!-- Mobile toggler -->
      <div class="float-right">
        <button
          class="navbar-toggler"
          type="button"
          @click="toggleMenu"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon">
            <img src="../../assets/icons/header/menu.svg" alt="Menu" class="toggler text-color" />
          </span>
        </button>
      </div>

      <div
        class="navbar-collapse flex-md-column collapse-right"
        :class="{ show: isMenuOpen }"
        id="navbarNavDropdown"
      >
        <button 
          type="button" 
          class="close-menu-btn" 
          aria-label="Close navigation" 
          @click="toggleMenu"
        >
        <img src="../../assets/icons/header/menu-close.svg" alt="Close" class="toggler text-color" />
        </button>
        <div class="nav-wrapper w-100 d-flex justify-content-between">
          <ul class="navbar-nav">

            <!-- Holiday Rentals (Ferienwohnung & Ferienhaus) -->
            <Dropdown :title="$t('base.header.menus.ferienwohnungen.title')">
              <!-- Regions (Dynamic) -->
              <InnerDropdown :title="$t('base.header.menus.ferienwohnungen.children.regions')">
                <DropdownItem
                  :closeOnClick="false"
                  v-for="region in regions"
                  :key="region.id"
                  :to="`/search?region=${region.id}`"
                  >{{ region.localizedName[$i18n.locale] }}</DropdownItem
                >
              </InnerDropdown>

              <!-- House Types (Dynamic) -->
              <InnerDropdown :title="$t('base.header.menus.ferienwohnungen.children.houseTypes')">
                <DropdownItem
                  :closeOnClick="false"
                  v-for="houseType in houseTypes"
                  :key="houseType.id"
                  :to="prepareSearchParams([], [houseType])"
                  >{{ houseType.localizedName | localized }}</DropdownItem
                >
              </InnerDropdown>

              <!-- Popular Options (Static) -->
              <InnerDropdown
                :title="$t('base.header.menus.ferienwohnungen.children.popularInTicino.title')"
              >
                <DropdownItem
                  :closeOnClick="false"
                  :to="prepareSearchParams(['childrenAllowed', 'ch'], [])"
                  >{{
                    $t("base.header.menus.ferienwohnungen.children.popularInTicino.children.family")
                  }}</DropdownItem
                >
                <DropdownItem
                  :closeOnClick="false"
                  v-if="houseTypes"
                  :to="
                    prepareSearchParams(
                      ['ch'],
                      [
                        houseTypes.find(
                          (el) => el.localizedName.de === 'Rustico'
                        ),
                      ]
                    )
                  "
                  >{{
                    $t("base.header.menus.ferienwohnungen.children.popularInTicino.children.rustici")
                  }}</DropdownItem
                >
                <DropdownItem
                  :closeOnClick="false"
                  :to="prepareSearchParams(['dogsAllowed', 'ch'], [])"
                  >{{
                    $t("base.header.menus.ferienwohnungen.children.popularInTicino.children.dog")
                  }}</DropdownItem
                >
                <DropdownItem
                  :closeOnClick="false"
                  :to="prepareSearchParams(['swimmingPool', 'ch'], [])"
                  >{{
                    $t("base.header.menus.ferienwohnungen.children.popularInTicino.children.pool")
                  }}</DropdownItem
                >
              </InnerDropdown>
              <DropdownItem :closeOnClick="false" href="/">{{
                $t("base.header.menus.ferienwohnungen.children.search")
              }}</DropdownItem>
              <DropdownItem
                :closeOnClick="false"
                :href="$t('base.header.menus.ferienwohnungen.children.publish.url')"
                >{{
                  $t("base.header.menus.ferienwohnungen.children.publish.title")
                }}</DropdownItem
              >
              <DropdownItem 
              :closeOnClick="false" 
              :href="$t('base.header.menus.common.discoverTicino.url')"
              >{{
              $t("base.header.menus.common.discoverTicino.title")
              }}</DropdownItem>
            </Dropdown>

            <!-- Real Estate (Immobilien) -->
            <Dropdown :title="$t('base.header.menus.immobilien.title')">
              <DropdownItem :closeOnClick="false" href="https://www.immobilien-tessin.ch/">{{
              $t("base.header.menus.immobilien.children.buy")
              }}</DropdownItem>
              <DropdownItem
              :closeOnClick="false"
              href="https://www.immobilien-tessin.ch/?type=mieten"
              >{{
                $t("base.header.menus.immobilien.children.rent")
              }}</DropdownItem
              >
              <DropdownItem
              :closeOnClick="false"
              :href="$t('base.header.menus.immobilien.children.sell.url')"
              >{{
                $t("base.header.menus.immobilien.children.sell.title")
              }}</DropdownItem
              >
              <DropdownItem 
              :closeOnClick="false" 
              :href="$t('base.header.menus.common.discoverTicino.url')"
              >{{
              $t("base.header.menus.common.discoverTicino.title")
              }}</DropdownItem>
            </Dropdown>

            <!-- Media (Single Link) -->
            <NavItem :closeOnClick="false" :href="$t('base.header.menus.media.url')">{{
              $t("base.header.menus.media.title")
            }}</NavItem>
            
            <!-- Property Valuation -->
            <NavItem :closeOnClick="false" :href="$t('base.header.menus.propertyValuation.url')">{{
              $t("base.header.menus.propertyValuation.title")
            }}</NavItem>


            <!-- About Us -->
            <Dropdown :title="$t('base.header.menus.aboutUs.title')">
              <DropdownItem :closeOnClick="false" :href="$t('base.header.menus.aboutUs.children.aboutCasafile.url')">{{
                $t("base.header.menus.aboutUs.children.aboutCasafile.title")
              }}</DropdownItem>
              <DropdownItem :closeOnClick="false" :href="$t('base.header.menus.aboutUs.children.team.url')">{{
                $t("base.header.menus.aboutUs.children.team.title")
              }}</DropdownItem>
              <DropdownItem :closeOnClick="false" :href="$t('base.header.menus.aboutUs.children.contact.url')">{{
                $t("base.header.menus.aboutUs.children.contact.title")
              }}</DropdownItem>
              <DropdownItem :closeOnClick="false" :href="$t('base.header.menus.aboutUs.children.media.url')">{{
                $t("base.header.menus.aboutUs.children.media.title")
              }}</DropdownItem>
              <DropdownItem :closeOnClick="false" :href="$t('base.header.menus.aboutUs.children.socialMedia.url')">{{
                $t("base.header.menus.aboutUs.children.socialMedia.title")
              }}</DropdownItem>
              <DropdownItem
                :closeOnClick="false"
                href="https://www.ticino.ch/en/plan/accommodation/holiday-houses/acav.html"
                >{{
                  $t("base.header.menus.aboutUs.children.ticinoTurismo")
                }}</DropdownItem
              >
              <DropdownItem :closeOnClick="false" href="https://acav-ticino.ch">{{
                $t("base.header.menus.aboutUs.children.acavTicino")
              }}</DropdownItem>
            </Dropdown>
          </ul>

          <ul class="navbar-nav">
            <!-- Client Login -->
            <NavItem :closeOnClick="false" :href="adminUrl">{{ $t("base.header.menus.login.title") }}</NavItem>

            <!-- Language Selector -->
            <HeaderLanguageSelector :isMobile="false"></HeaderLanguageSelector>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Dropdown from "./components/Dropdown";
import HeaderLanguageSelector from "./components/HeaderLanguageSelector";
import InnerDropdown from "./components/InnerDropdown";
import NavItem from "./components/NavItem";
import DropdownItem from "./components/DropdownItem";
import SEOBanner from "@/base/SEOBanner";
import LanguageSelector from "@/components/common/LanguageSelector";
export default {
  name: "Header",
  components: {
    Dropdown,
    HeaderLanguageSelector,
    InnerDropdown,
    DropdownItem,
    NavItem,
    SEOBanner,
    LanguageSelector,
  },
  data() {
    return {
      adminUrl: process.env.VUE_APP_ADMIN_URL,
      isMenuOpen: false,
    };
  },
  computed: {
    regions: function () {
      let currentLocale = this.$i18n.locale;
      let regions = this.$store.getters.getRegions;

      return regions === undefined
        ? []
        : regions.sort((a, b) => (a.sequence < b.sequence ? -1 : 1));
    },
    houseTypes: function () {
      let currentLocale = this.$i18n.locale;
      let houseTypes = this.$store.getters.getHouseTypes;

      return houseTypes === undefined
        ? []
        : houseTypes.sort((a, b) =>
            a.localizedName[currentLocale].localeCompare(
              b.localizedName[currentLocale]
            )
          );
    },
    query: function () {
      return this.$store.getters.getQuery;
    },
  },
  methods: {
    goToRegion: function (region) {
      // We first reset all other params
      this.$store.commit("setBaseQuery");

      // Then navigate to the region
      this.$router.push(region.url);
    },
    searchAll: function () {
      // Set the base query
      this.$store.commit("setBaseQuery");

      // Navigate to the view
      this.$router.push("/search");
    },
    prepareSearchParams: function (props, houseTypes) {
      let propsArray = props.map((el) => `${el}=true`);
      
      let houseTypesArray = houseTypes
        .map((houseType) => {
          let locale = this.$i18n.locale;

          let isDefined =
            !this.isUndefined(houseType) &&
            !this.isUndefined(houseType.localizedName);

          return isDefined
            ? `houseType=${encodeURIComponent(houseType.localizedName[locale])}`
            : undefined;
        })
        .filter((el) => el !== undefined);

      return `/search?${propsArray.concat(houseTypesArray).join("&")}`;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
$mobile-menu-height: 64px;

@media (max-width: 991.98px) {
  .navbar {
    padding: 0 1.5rem;
    position: sticky !important;
    top: 0;
    height: $mobile-menu-height; 
    background-color: $white !important;
    margin-bottom: 0px;
  }

  .nav-wrapper {
    flex-direction: column;
    align-items: flex-start; 
  }

  .navbar-nav {
    align-items: flex-start; 
    width: 100%;
  }

  #logoImage {
    margin-top: 5px;
  }

  .collapse-right {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: 50%; 
    min-width: 320px; 
    background-color: $primary-dark;
    overflow-y: auto;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    transform: translateX(100%);
    z-index: 1050;
    padding-top: $mobile-menu-height;
  }

  .collapse-right.show {
    transform: translateX(0);
  }

  .close-menu-btn {
    position: absolute;
    top: 0;
    right: 1.5rem; 
    height: $mobile-menu-height;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    font-size: 1.5rem;
    color: $text-color;
    z-index: 1100;
  }

}

@media (min-width: 992px) {
  .navbar {
    padding: 0 2.25rem;
    min-height: $navbar-height;
    background-color: white !important;
    margin-bottom: 0px;
  }

  .navbar-brand {
    height: $navbar-height;
    line-height: $navbar-height;
  }

  #navbarNavDropdown,
  .navbar-nav {
    height: $navbar-height;
  }

  .close-menu-btn {
    display: none;
  }
}

.navbar-toggler {
  background-color: $primary-color !important;
  padding: 5px;
}

.toggler {
  height: 30px;
  width: 30px;
  text-align: center;
}

.navbar-brand {
  padding: 0;
  margin: 0;
}

#logoImage {
  padding: 0;
  width: 220px;
  height: auto;
}

.text-color {
  color: $text-color;
}

.float-right button {
  background-color: $white !important;
}
</style>

